import { Component, ElementRef, AfterViewInit, OnDestroy, Input, EventEmitter, Renderer } from '@angular/core';
import { DomHandler } from '../../../core/dom/domhandler';
import { ConfirmationService } from './confirmation.service';
import { Subscription } from 'rxjs/Subscription';
import { Confirmation } from '../confirmation';


@Component({
  selector: 'confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss',
    '../../../../assets/stylesheets/button.scss']
})
export class ConfirmationComponent implements AfterViewInit, OnDestroy {

  @Input() header: string;

  @Input() icon: string;

  @Input() message: string;

  @Input() acceptIcon: string = 'fa-check';

  @Input() acceptLabel: string = 'Yes';

  @Input() acceptVisible: boolean = true;

  @Input() rejectIcon: string = 'fa-close';

  @Input() rejectLabel: string = 'No';

  @Input() rejectVisible: boolean = true;

  @Input() width: any;

  @Input() height: any;

  @Input() closeOnEscape: boolean = true;

  @Input() rtl: boolean;

  @Input() closable: boolean = true;

  @Input() responsive: boolean = true;

  @Input() appendTo: any;

  @Input() key: string;

  confirmation: Confirmation;

  _visible: boolean;

  documentEscapeListener: any;

  documentResponsiveListener: any;

  mask: any;

  contentContainer: any;

  positionInitialized: boolean;

  subscription: Subscription;

  constructor(public el: ElementRef, public domHandler: DomHandler,
    public renderer: Renderer, private confirmationService: ConfirmationService) {
    this.subscription = this.confirmationService.requireConfirmation$.subscribe(confirmation => { // todo
      if (confirmation.key === this.key) {
        this.confirmation = confirmation;
        this.message = this.confirmation.message || this.message;
        this.icon = this.confirmation.icon || this.icon;
        this.header = this.confirmation.header || this.header;
        this.rejectVisible = this.confirmation.rejectVisible === null ? this.rejectVisible : this.confirmation.rejectVisible;
        this.acceptVisible = this.confirmation.acceptVisible === null ? this.acceptVisible : this.confirmation.acceptVisible;

        if (this.confirmation.accept) {
          this.confirmation.acceptEvent = new EventEmitter();
          this.confirmation.acceptEvent.subscribe(this.confirmation.accept);
        }

        if (this.confirmation.reject) {
          this.confirmation.rejectEvent = new EventEmitter();
          this.confirmation.rejectEvent.subscribe(this.confirmation.reject);
        }

        this.visible = true;
      }
    });
  }

  @Input() get visible(): boolean {
    return this._visible;
  }

  set visible(val: boolean) {
    this._visible = val;

    if (this._visible) {
      if (!this.positionInitialized) {
        this.center();
        this.positionInitialized = true;
      }

      this.el.nativeElement.children[0].style.zIndex = ++DomHandler.zindex;
    }

    if (this._visible)
      this.enableModality();
    else
      this.disableModality();
  }

  ngAfterViewInit() {
    this.contentContainer = this.domHandler.findSingle(this.el.nativeElement, '.hx-ui-dialog-content');

    if (this.responsive) {
      this.documentResponsiveListener = this.renderer.listenGlobal('window', 'resize', (event) => {

        this.center();
      });
    }

    if (this.closeOnEscape && this.closable) {
      this.documentEscapeListener = this.renderer.listenGlobal('body', 'keydown', (event) => {
        if (event.which === 27) {
          if (this.el.nativeElement.children[0].style.zIndex === DomHandler.zindex) {
            this.hide(event);
          }
        }
      });
    }

    if (this.appendTo) {
      if (this.appendTo === 'body')
        document.body.appendChild(this.el.nativeElement);
      else
        this.domHandler.appendChild(this.el.nativeElement, this.appendTo);
    }
  }

  center() {
    let container = this.el.nativeElement.children[0];
    let elementWidth = this.domHandler.getOuterWidth(container);
    let elementHeight = this.domHandler.getOuterHeight(container);
    if (elementWidth === 0 && elementHeight === 0) {
      container.style.visibility = 'hidden';
      container.style.display = 'block';
      elementWidth = this.domHandler.getOuterWidth(container);
      elementHeight = this.domHandler.getOuterHeight(container);
      container.style.display = 'none';
      container.style.visibility = 'visible';
    }
    let viewport = this.domHandler.getViewport();
    let x = (viewport.width - elementWidth) / 2;
    let y = (viewport.height - elementHeight) / 2;

    container.style.left = x + 'px';
    container.style.top = y + 'px';
  }

  enableModality() {
    if (!this.mask) {
      this.mask = document.createElement('div');
      this.mask.style.zIndex = this.el.nativeElement.children[0].style.zIndex - 1;
      this.domHandler.addMultipleClasses(this.mask, 'hx-ui-widget-overlay hx-ui-dialog-mask');
      document.body.appendChild(this.mask);
    }
  }

  disableModality() {
    if (this.mask) {
      document.body.removeChild(this.mask);
      this.mask = null;
    }
  }

  hide(event?: Event) {
    this.visible = false;

    if (event) {
      event.preventDefault();
    }
  }

  moveOnTop() {
    this.el.nativeElement.children[0].style.zIndex = ++DomHandler.zindex;
  }

  ngOnDestroy() {
    this.disableModality();

    if (this.documentResponsiveListener) {
      this.documentResponsiveListener();
    }

    if (this.documentEscapeListener) {
      this.documentEscapeListener();
    }

    if (this.appendTo && this.appendTo === 'body') {
      document.body.removeChild(this.el.nativeElement);
    }

    this.subscription.unsubscribe();
  }

  accept() {
    if (this.confirmation.acceptEvent) {
      this.confirmation.acceptEvent.emit();
    }

    this.hide();
    this.confirmation = null;
  }

  reject() {
    if (this.confirmation.rejectEvent) {
      this.confirmation.rejectEvent.emit();
    }

    this.hide();
    this.confirmation = null;
  }
}
